import { render, staticRenderFns } from "./ConfigurablePartsModule.vue?vue&type=template&id=83c2d050&"
import script from "./ConfigurablePartsModule.vue?vue&type=script&lang=js&"
export * from "./ConfigurablePartsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports